import { hardwareTypeFromDto } from '@cas/utils/translationHelpers';
import { VdsBadgePill } from '@volt/volt-extended-components-react';

export interface CasDeviceTypeProps {
  hardwareType: string;
}

export function CasHardwareType({ hardwareType }: CasDeviceTypeProps) {
  return (
    <VdsBadgePill
      value={hardwareTypeFromDto(hardwareType)}
      size="extra-small"
      statusColor="neutral"
    />
  );
}

export default CasHardwareType;
